import { useState } from "react";
import { Link } from "react-router-dom";
import { Wind, Menu, X } from "lucide-react";
import { Button } from "./ui/button";
import InstallButton from "./InstallButton";

const LINKS = [
  { href: "/#features", label: "Features" },
  { href: "/#how", label: "How it works" },
  { href: "/pricing", label: "Pricing", route: true },
  { href: "/compare", label: "Compare", route: true },
  { href: "/guides", label: "Guides", route: true },
  { href: "/blog", label: "Blog", route: true },
  { href: "/service-areas", label: "Cities", route: true },
  { href: "/#contact", label: "Contact" },
];

// Shared site header/nav used on the homepage and other marketing pages.
export default function SiteNav() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/90 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-indigo-500">
            <Wind className="h-5 w-5 text-white" strokeWidth={2.5} />
          </div>
          <span className="font-heading text-xl font-black text-slate-900">Fast Estimate</span>
        </Link>
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => l.route ? (
            <Link key={l.label} to={l.href} data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm font-semibold text-slate-600 hover:text-slate-900">{l.label}</Link>
          ) : (
            <a key={l.label} href={l.href} className="text-sm font-semibold text-slate-600 hover:text-slate-900">{l.label}</a>
          ))}
        </nav>
        <div className="hidden items-center gap-3 md:flex">
          <InstallButton className="h-11 rounded-xl border-2 font-bold text-slate-700" />
          <Link to="/login"><Button data-testid="nav-signin" variant="ghost" className="h-11 font-bold text-slate-700">Sign in</Button></Link>
          <Link to="/signup"><Button data-testid="nav-signup" className="h-11 rounded-xl bg-indigo-500 px-5 font-bold hover:bg-indigo-600">Start your free trial</Button></Link>
        </div>
        <button className="md:hidden" data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)}>
          {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </div>
      {open && (
        <div className="border-t border-slate-200 bg-white px-4 py-4 md:hidden">
          {LINKS.map((l) => l.route ? (
            <Link key={l.label} to={l.href} onClick={() => setOpen(false)} className="block py-3 text-base font-semibold text-slate-700">{l.label}</Link>
          ) : (
            <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="block py-3 text-base font-semibold text-slate-700">{l.label}</a>
          ))}
          <div className="mt-3 flex flex-col gap-2">
            <InstallButton className="h-12 w-full rounded-xl border-2 font-bold text-slate-700" testid="install-app-btn-mobile" />
            <Link to="/login"><Button variant="outline" className="h-12 w-full rounded-xl font-bold">Sign in</Button></Link>
            <Link to="/signup"><Button className="h-12 w-full rounded-xl bg-indigo-500 font-bold">Start your free trial</Button></Link>
          </div>
        </div>
      )}
    </header>
  );
}
